import startCase from 'lodash/startCase';

const capitalize = value => startCase(value.toLowerCase());

function camelCase(string) {
  string = string.replace(/[^a-zA-Z0-9]+(.)/g, (_, chr) => chr.toUpperCase());
  return string.charAt(0).toLowerCase() + string.slice(1);
}

export {
  capitalize,
  camelCase
}
